import React from 'react';
import '../Styles/Footer.css';
import { FaInstagram } from 'react-icons/fa6';
import { FaMapMarkerAlt, FaEnvelope } from 'react-icons/fa';
import { Link } from 'react-router-dom';

import logowithname from '../images/Groomwell_icon.jpg';

const Footer = () => {
  return (
    <footer className="salon_footer_root">
      <div className="salon_footer_top">
        {/* Logo Section */}
        <div className="salon_footer_column1">
          <img
            className="salon_footer_logo"
            src={logowithname}
            alt="Groomwell Women's Salon Logo - Best Salon in Hafeezpet Hyderabad"
          />
        </div>

        {/* Services Section */}
        <div className="salon_footer_column">
          <p className="salon_footer_heading">Salon Services</p>
          <ul>
            <li>Hair Care</li>
            <li>Hair Makeover</li>
            <li>Facials</li>
            <li>Grooming</li>
            <li>Nail Art</li>
          </ul>
        </div>

        {/* Navigation Links */}
        <div className="salon_footer_column">
          <p className="salon_footer_heading">Quick Links</p>
          <nav aria-label="Footer Navigation">
            <ul>
              <li>
                <Link to="/" className="salon_footer_link" title="Go to Groomwell Salon Home">Home</Link>
              </li>
              <li>
                <Link to="/Services" className="salon_footer_link" title="Explore Groomwell Salon Services">Services</Link>
              </li>
              <li>
                <Link to="/GalleryPage" className="salon_footer_link" title="View Groomwell Salon Gallery">Gallery</Link>
              </li>
              <li>
                <Link to="/Contact" className="salon_footer_link" title="Contact Groomwell Salon">Contact Us</Link>
              </li>
              <li>
                <Link to="/FAQ" className="salon_footer_link" title="Frequently Asked Questions">FAQ</Link>
              </li>
            </ul>
          </nav>
        </div>

        {/* Contact / Address Section */}
        <div className="salon_footer_column">
          <p className="salon_footer_heading">Visit Us</p>
          <address>
            <p>
              <FaMapMarkerAlt className="salon_footer_icon" />
              <a
                href="https://www.google.com/maps/place/GROOM+WELL/@17.485608,78.356504"
                target="_blank"
                rel="noopener noreferrer"
                className="salon_footer_address"
                title="Find Groomwell Salon on Google Maps"
              >
                115/99(P)87, Manjeera Pipeline Rd, above SBI BANK,  
                Vinayaka Nagar, Hafeezpet, Hyderabad, Telangana 500049
              </a>
            </p>
            <p>
              <a
                href="mailto:groomwellsalon.co.in@gmail.com"
                className="salon_footer_email"
                title="Email Groomwell Salon"
              >
                <FaEnvelope className="salon_footer_icon" />
                groomwellsalon.co.in@gmail.com
              </a>
            </p>
          </address>
        </div>
      </div>

      {/* Social Media */}
      <div className="salon_footer_social">
        <p>Follow us for style tips & updates:</p>
        <div className="salon_footer_icons">
          <a
            href="https://www.instagram.com/invites/contact/?utm_source=ig_contact_invite&utm_medium=copy_link&utm_content=z4t1rap"
            target="_blank"
            rel="nofollow noopener noreferrer"
            aria-label="Follow Groomwell Salon on Instagram"
            title="Groomwell Salon Instagram"
          >
            <FaInstagram />
          </a>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="salon_footer_bottom">
        <p>© 2025 Groomwell Salon, Hafeezpet, Hyderabad. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
